import { ref } from 'vue';
import { createSharedComposable } from '@vueuse/core';
import { api } from '/app/plugins/services';
import { singleFlight } from '/app/utils/single-flight';

export const useAppState = createSharedComposable(() => {
    const sidebarCollapsed = ref(false);
    const contextUser = ref({ user: {} });
    const platformCategories = ref([]);

    function setSidebarCollapsed(value) {
        sidebarCollapsed.value = value;
    }

    function toggleSidebarCollapsed(value) {
        sidebarCollapsed.value = value ?? !sidebarCollapsed.value;
    }

    function setContextUser(user) {
        contextUser.value = user;
    }

    function resetUser() {
        contextUser.value = { user: {} };
    }

    async function fetchUser(slug) {
        resetUser();
        const { data: response } = await api.user.detailed(slug);
        if (!response?.data?.user) {
            return; // keep the { user: {} } invariant from resetUser()
        }
        contextUser.value = response.data;
        return response.data;
    }

    // `platform:change` can fire more than once before the request settles.
    const fetchCategories = singleFlight(async (platform) => {
        try {
            const { data: response } = await api.challenges.categories(platform?.id || platform);
            platformCategories.value = response.data;
        } catch (err) {
            // ignore
        }
    }, (platform) => platform?.id || platform);

    return {
        sidebarCollapsed,
        contextUser,
        platformCategories,
        setSidebarCollapsed,
        toggleSidebarCollapsed,
        setContextUser,
        resetUser,
        fetchUser,
        fetchCategories,
    };
});
